import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaCpdCoursesCreator,
  setMaCpdCoursesPageCreator,
  setMaCpdCoursesPerPageCreator,
  setMaCpdCoursesSortCreator,
  setMaCpdCoursesFiltersCreator,
} from '../../../../store/actionsCreators';
import Courses from '../../../../shared/Cpd/Courses/Courses';

const mapStateToProps = ({ loading, ma }) => ({
  loading: isLoading(loading, 'LOAD_MA_CPD_COURSES'),
  list: ma.cpdCourses,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaCpdCoursesCreator()),
  setPage: (payload) => dispatch(setMaCpdCoursesPageCreator(payload)),
  setPerPage: (payload) => dispatch(setMaCpdCoursesPerPageCreator(payload)),
  setSort: (payload) => dispatch(setMaCpdCoursesSortCreator(payload)),
  setFilters: (payload) => dispatch(setMaCpdCoursesFiltersCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Courses);
